import React from 'react';
import { TextWidget } from '@plone/volto/components';

const LuogoEdit = (props) => {
  const { content, onChange } = props;

  return (
    <div className="luogo-edit">
      <h1>Modifica Luogo: {content.title}</h1>
      
      <TextWidget
        id="indirizzo"
        title="Indirizzo"
        value={content.indirizzo || ''}
        onChange={(id, value) => onChange(id, value)}
      />
      
      {/* Aggiungi altri widget qui */}
    </div>
  );
};

export default LuogoEdit;